<template>
  <van-popup
    v-model:show="visible"
    :position="position"
    :close-on-click-overlay="closeOnClickOverlay"
    teleport="body"
  >
    <div class="popup-view" :style="popupStyle">
      <slot name="content"></slot>

      <div v-if="closeable" class="close-icon-box" @click="close">
        <van-icon name="cross" size="24" color="#FFFFFF" />
      </div>
    </div>
  </van-popup>
</template>

<script setup>
const visible = ref(false)

const props = defineProps({
  height: { type: [Number, String], default: 100 },
  closeOnClickOverlay: { type: Boolean, default: false },
  position: { type: String, default: 'center' },
  closeable: { type: Boolean, default: false },
})

const popupStyle = computed(() => {
  const obj = {
    height: !isNaN(props.height) ? `${props.height}vh` : `${props.height}`,
  }

  return obj
})

const open = () => {
  visible.value = true
}

const close = () => {
  emit('close')
  visible.value = false
}

const emit = defineEmits(['close'])

defineExpose({ open, close })
</script>

<style scoped lang="scss">
.popup-view {
  position: relative;
  width: 100vw;
  overflow-y: auto;

  .close-icon-box {
    position: fixed;
    top: 40px;
    right: 20px;
  }
}
</style>
